export default __webpack_public_path__ + "static/media/AdobeStock_213598260.5c74ebef.jpg";